module.exports = __webpack_public_path__ + "img/nerf_snapchat.4b5be6d3.jpg";